(function () {
  'use strict';

  function buildSlide(item) {
    var slide = document.createElement('div');
    slide.className = 'seen-real-bodies__slide';
    slide.setAttribute('data-slide', '');
    var card = document.createElement('div');
    card.className = 'seen-real-bodies__card';

    if (item.type === 'video' && item.url) {
      var video = document.createElement('video');
      video.className = 'seen-real-bodies__video';
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', 'true');
      video.preload = 'metadata';
      if (item.poster) video.poster = item.poster;
      video.setAttribute('data-lazy-video', '');
      var source = document.createElement('source');
      source.src = item.url;
      source.type = 'video/mp4';
      video.appendChild(source);
      card.appendChild(video);
    } else if (item.url) {
      var img = document.createElement('img');
      img.className = 'seen-real-bodies__img';
      img.alt = 'Wearth customer photo';
      img.width = 900;
      img.height = 1200;
      img.loading = 'lazy';
      img.decoding = 'async';
      img.setAttribute('data-lazy-img', '');
      img.setAttribute('data-src', item.url);
      img.setAttribute('sizes', '(min-width: 990px) 32vw, (min-width: 750px) 45vw, 88vw');
      card.appendChild(img);
    }

    slide.appendChild(card);
    return slide;
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  function getImgFullSrc(img) {
    if (!img) return '';
    return (
      img.getAttribute('data-src') ||
      img.currentSrc ||
      img.src ||
      ''
    );
  }

  function ensureLightbox() {
    var lb = document.getElementById('seen-real-bodies-lightbox');
    if (lb) return lb;
    lb = document.createElement('div');
    lb.id = 'seen-real-bodies-lightbox';
    lb.className = 'seen-real-bodies__lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Customer photo');
    lb.innerHTML =
      '<button type="button" class="seen-real-bodies__lightbox-close" aria-label="Close">&times;</button>' +
      '<img class="seen-real-bodies__lightbox-img" alt="Wearth customer photo" decoding="async">';
    document.body.appendChild(lb);
    var closeBtn = lb.querySelector('.seen-real-bodies__lightbox-close');
    function close() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    closeBtn.addEventListener('click', close);
    lb.addEventListener('click', function (e) {
      if (e.target === lb) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lb.classList.contains('is-open')) close();
    });
    return lb;
  }

  function openLightbox(src) {
    if (!src || !isDesktop()) return;
    var lb = ensureLightbox();
    var big = lb.querySelector('.seen-real-bodies__lightbox-img');
    big.src = src.replace(/width=\d+/, 'width=1600');
    lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    lb.querySelector('.seen-real-bodies__lightbox-close').focus();
  }

  function bindDesktopLightbox(root) {
    if (!isDesktop()) return;
    root.querySelectorAll('.seen-real-bodies__card').forEach(function (card) {
      var img = card.querySelector('.seen-real-bodies__img');
      if (!img) return;
      card.classList.add('seen-real-bodies__card--clickable');
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-label', 'View customer photo');
      function openFromCard() {
        openLightbox(getImgFullSrc(img));
      }
      card.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openFromCard();
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openFromCard();
        }
      });
    });
  }

  function hydrateFromMap(root) {
    var handle = root.getAttribute('data-product-handle') || '';
    var mapUrl = root.getAttribute('data-map-url') || '';
    var track = root.querySelector('[data-track]');
    if (!handle || !mapUrl || !track || track.querySelector('[data-slide]')) {
      return Promise.resolve(false);
    }
    return fetch(mapUrl, { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (map) {
        var items = map[handle] || [];
        if (!items.length) return false;
        items.forEach(function (item) {
          track.appendChild(buildSlide(item));
        });
        return true;
      })
      .catch(function () {
        return false;
      });
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-track]');
    var viewport = root.querySelector('[data-viewport]');
    var slides = root.querySelectorAll('[data-slide]');
    var dotsWrap = root.querySelector('[data-dots]');
    var prevBtn = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    if (!track || !slides.length) return;

    var index = 0;
    var timer = null;
    var interval = parseInt(root.getAttribute('data-interval') || '4000', 10);
    var touchStartX = 0;
    var touchDeltaX = 0;

    function slideWidth() {
      var slide = slides[0];
      if (!slide) return viewport ? viewport.clientWidth : 0;
      var style = window.getComputedStyle(slide);
      var w = slide.getBoundingClientRect().width;
      var margin =
        parseFloat(style.marginLeft || 0) + parseFloat(style.marginRight || 0);
      return w + margin;
    }

    function maxIndex() {
      var visible = 1;
      var pdpInline = root.classList.contains('seen-real-bodies--pdp-inline');
      // PDP inline: always one slide per view so 2-slide carousels (photo + video) can advance.
      if (!pdpInline) {
        if (window.matchMedia('(min-width: 990px)').matches) {
          visible = 3;
        } else if (window.matchMedia('(min-width: 750px)').matches) {
          visible = 2;
        }
      }
      return Math.max(0, slides.length - visible);
    }

    function goTo(i, animate) {
      var max = maxIndex();
      index = Math.max(0, Math.min(i, max));
      var offset = index * slideWidth();
      track.style.transition = animate === false ? 'none' : '';
      track.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';
      updateDots();
    }

    function updateDots() {
      if (!dotsWrap) return;
      var buttons = dotsWrap.querySelectorAll('.seen-real-bodies__dot');
      buttons.forEach(function (btn, i) {
        btn.classList.toggle('is-active', i === index);
        btn.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var count = maxIndex() + 1;
      for (var i = 0; i < count; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'seen-real-bodies__dot' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-label', 'Slide ' + (i + 1));
        btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        (function (n) {
          btn.addEventListener('click', function () {
            stopAutoplay();
            goTo(n);
            startAutoplay();
          });
        })(i);
        dotsWrap.appendChild(btn);
      }
    }

    function startAutoplay() {
      stopAutoplay();
      timer = window.setInterval(function () {
        var max = maxIndex();
        goTo(index >= max ? 0 : index + 1);
      }, interval);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function lazyLoad() {
      root.querySelectorAll('[data-lazy-img]').forEach(function (img) {
        if (img.dataset.loaded === '1') return;
        var src = img.getAttribute('data-src');
        if (!src) return;
        img.src = src;
        img.dataset.loaded = '1';
      });
      root.querySelectorAll('[data-lazy-video]').forEach(function (video) {
        if (video.dataset.loaded === '1') return;
        video.dataset.loaded = '1';
        video.play().catch(function () {});
      });
    }

    function observeSection() {
      if (!('IntersectionObserver' in window)) {
        lazyLoad();
        startAutoplay();
        return;
      }
      var obs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              lazyLoad();
              startAutoplay();
              obs.disconnect();
            }
          });
        },
        { rootMargin: '80px' }
      );
      obs.observe(root);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stopAutoplay();
        goTo(index - 1);
        startAutoplay();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stopAutoplay();
        goTo(index + 1);
        startAutoplay();
      });
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    if (viewport) {
      viewport.addEventListener(
        'touchstart',
        function (e) {
          touchStartX = e.changedTouches[0].screenX;
          touchDeltaX = 0;
          stopAutoplay();
        },
        { passive: true }
      );
      viewport.addEventListener(
        'touchmove',
        function (e) {
          touchDeltaX = e.changedTouches[0].screenX - touchStartX;
        },
        { passive: true }
      );
      viewport.addEventListener(
        'touchend',
        function () {
          if (Math.abs(touchDeltaX) > 40) {
            goTo(touchDeltaX < 0 ? index + 1 : index - 1);
          }
          startAutoplay();
        },
        { passive: true }
      );
    }

    window.addEventListener('resize', function () {
      slides = root.querySelectorAll('[data-slide]');
      buildDots();
      goTo(index, false);
    });

    buildDots();
    goTo(0, false);
    observeSection();
    bindDesktopLightbox(root);
  }

  function initSection(root) {
    if (!root || root.dataset.seenInit === '1') return;
    root.dataset.seenInit = '1';

    var hasSlides = root.querySelector('[data-slide]');
    if (hasSlides) {
      initCarousel(root);
      return;
    }

    hydrateFromMap(root).then(function (ok) {
      if (ok) initCarousel(root);
    });
  }

  function boot() {
    document.querySelectorAll('[data-seen-real-bodies]').forEach(initSection);
  }

  window.initSeenRealBodies = boot;
  document.addEventListener('seen-real-bodies-hydrated', boot);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
